export default __webpack_public_path__ + "static/media/close.3bee9fde.svg";